// extracted by mini-css-extract-plugin
module.exports = {"meeting":"_3284028","venue":"_d23aa98"};